// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"b8dcd13a","636":"dcd4d4ce"}[chunkId] + ".chunk.css";
};